<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-top:150px;">About the Author</h1>
<p>Susu Smitzh was born and grew up in South Asia, now living in Sydney, Australia. She is married and a mother of a daughter. She likes drawing, sudoku, watching documentaries, cooking and 50% discounts. This is her very first book.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?5a492ace